import React, { useEffect, useState, useMemo, useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import API_ROUTES from '../../api';
import axios from 'axios';
import {
    Card, Grid, Image, NavBar, Empty,
    Toast, Dialog, Selector, PullToRefresh, Badge
} from 'antd-mobile';
import './applicateTwoButtons.css';
import '../../styles/components/match-members.css'
import { DownOutline } from 'antd-mobile-icons'
import GameTitleTeam from './gameTitleTeam';
import AddReferee from '../ApplicateOne/addReferee';
import AddTempMember from '../ApplicateOne/addTempMember';
import TempSignupPopup from './tempSignupPopup';
import AttendanceManagePopup from './attendanceManagePopup';
import LazySignupPopup from './lazySignupPopup';
import Icon from '../../icon';
import DinnerInfo from '../../Dinner/DinnerInfo';
import GameFirstInfo from './gameFirstInfo';
import GameStep from './gameStep';
import GameReadyStepOne from './gameReady/gameReadyStepOne';
import { useGameRouteId } from '../../features/match/hooks/useGameRouteId';
import { useAuth } from '../../app/providers/AuthProvider';
import { getCaptainWorkflow } from '../../features/match/model/captainWorkflow';
import { getReadyTeamName } from '../../features/match/model/readyTeamName';
import { gameYearApi } from '../../features/game-year/api/gameYearApi';

export default function ApplicateTwo() {
    const navigate = useNavigate()
    const location = useLocation()
    const { memberInfo } = useAuth()
    const gameId = useGameRouteId('ready');
    const [joinButtonLoading, setJoinButtonLoading] = useState(false)

    const [memberListInfo, setMemberListInfo] = useState([])

    const [gameDetail, setGameDetail] = useState("")
    const [yearStatus, setYearStatus] = useState(null)
    const currentYearId = gameDetail?.yearGameId || location.state?.gameYearId
    const redCaptian = memberListInfo?.find(item => item.id === gameDetail.redCaptainId)
    const greenCaptain = memberListInfo?.find(item => item.id === gameDetail.greenCaptainId)

    const refereeListInfo = memberListInfo?.length > 0 ?
        memberListInfo?.filter(item => item.gameType === 1 || item.gameType === 2) : []
    // 管理员和当场裁判共享赛前阵容管理权限，并兼容空登录态。
    const canManageMatch = memberInfo?.admin === 1
        || refereeListInfo.some(referee => referee.id === memberInfo?.id)
    const captainWorkflow = useMemo(() => getCaptainWorkflow(gameDetail), [gameDetail])
    // 报名结束且双方队长完成选队后，管理员可在赛前管理中对调两队队员。
    const canSwapTeamMembers = captainWorkflow.canSwapCaptains
        && memberInfo?.admin === 1
        && Number(gameDetail?.gameType) === 3
        && Number(gameDetail?.statusInfo) === 1
    // 待选身份按实际比赛归属判断，不依赖位置编号；本人在选队前后都能看到入口。
    const hasPendingTeamMembers = memberListInfo.some(item => item.gameType === 0 && item.gameTeam === null)
    const isPendingTeamMember = memberInfo?.id != null && memberListInfo.some(item => (
        item.gameType === 0 && item.gameTeam === null && String(item.id) === String(memberInfo.id)
    ))
    const canAccessTeamSetup = captainWorkflow.showTeamSetup && (
        [redCaptian?.id, greenCaptain?.id].includes(memberInfo?.id)
        || isPendingTeamMember
        || memberInfo?.captain === 1
        || canManageMatch
    )

    const [tempLocalPos, setTempLocalPos] = useState([])
    const [activeTab, setActiveTab] = useState('team');
    const [attendanceUser, setAttendanceUser] = useState(null);
    const [lazySignupUser, setLazySignupUser] = useState(null);


    const getGameDetail = useCallback(() => {
        Toast.show({
            icon: 'loading',
            duration: 0,
        })
        axios.get(API_ROUTES.game_info, {
            params: {
                id: gameId
            }
        })
            .then(function (response) {
                const result = response.data.data
                if (result.statusInfo === 1) {
                    setGameDetail(response.data.data)
                } else {
                    navigate('/home')
                }
            })
            .catch(function (error) {
                console.error('Error fetching user list:', error);
            })
            .finally(() => {
                Toast.clear()
            });
    }, [gameId, navigate])

    const getUserListInfo = useCallback(() => {
        Toast.show({
            icon: 'loading',
            duration: 0,
        })
        axios.get(API_ROUTES.member_gameList, {
            params: {
                gameId: gameId
            }
        })
            .then(function (response) {
                if (response.data.code === 200) {
                    setMemberListInfo(response.data.data)
                } else {
                    Toast.show({
                        content: response.data.msg,
                        icon: 'fail',
                    })
                }
            })
            .catch(function (error) {
                Toast.show({
                    content: error,
                    icon: 'fail',
                })
            })
            .finally(() => {
                Toast.clear()
            });
    }, [gameId])

    useEffect(() => {
        if (!gameId) return
        getGameDetail()
        getUserListInfo()
        if (!localStorage.getItem("memberTempPos")) {
            localStorage.setItem("memberTempPos", JSON.stringify([]))
        } else {
            const res = JSON.parse(localStorage.getItem("memberTempPos"))
            setTempLocalPos(res)
        }
    }, [gameId, getGameDetail, getUserListInfo]);

    useEffect(() => {
        // 服务端把双方阵型退回未选择时，清除本机遗留的首发草稿，避免再次显示旧队员。
        if (String(gameDetail?.id) !== String(gameId) || Number(gameDetail?.gameType) !== 3
            || Number(gameDetail?.greenCaptainConfirm) !== 1 || Number(gameDetail?.redCaptainConfirm) !== 1
            || gameDetail?.greenModel != null || gameDetail?.redModel != null) return
        setTempLocalPos([])
        localStorage.removeItem('memberTempPos')
    }, [gameDetail?.id, gameDetail?.gameType, gameDetail?.greenCaptainConfirm,
        gameDetail?.redCaptainConfirm, gameDetail?.greenModel, gameDetail?.redModel, gameId])

    useEffect(() => {
        // 年会赛前页直接读取活动状态，避免阵容确认后才发现活动尚未开始。
        if (Number(gameDetail?.gameType) !== 4 || !currentYearId) return;
        gameYearApi.getInfo(currentYearId).then(response => {
            setYearStatus(response.data.data?.status ?? null);
        }).catch(() => setYearStatus(null));
    }, [gameDetail?.gameType, currentYearId]);

    const startReadyMatch = async (startYearFirst = false) => {
        setJoinButtonLoading(true);
        try {
            if (startYearFirst) {
                const yearResult = await gameYearApi.save({ id: currentYearId, status: 1 });
                if (yearResult.data.code !== 200 || yearResult.data.data === false) {
                    Toast.show({ icon: 'fail', content: yearResult.data.msg || '年会活动启动失败' });
                    return;
                }
                setYearStatus(1);
            }
            const response = await axios.post(API_ROUTES.game_changeGameInfo, { id: gameDetail.id, status: 2 });
            if (response.data.code !== 200 || response.data.data === false) {
                Toast.show({ icon: 'fail', content: response.data.msg || '开赛失败，请检查队长确认情况' });
                return;
            }
            Toast.show({ icon: 'success', content: '比赛开始成功！' });
            navigate(`/games/${gameId}/live`);
        } catch (error) {
            Toast.show({ icon: 'fail', content: error?.response?.data?.msg || '开赛失败，请重试' });
        } finally {
            setJoinButtonLoading(false);
        }
    }

    const getTeamColorType = (color) => {
        if (color === 'red') return 2;
        if (color === 'green') return 1;
        if (color === '#CCCCFF' || color === 'purple') return 5;
        return 0;
    };

    const getTeamDefaultAvatar = (type) => {
        if (type === 1) return Icon.GREEN_DEFAILT_AVATAR;
        if (type === 2) return Icon.RED_DEFAILT_AVATAR;
        if (type === 5) return Icon.PURPLE_DEFAILT_AVATAR;
        return Icon.KEPENG_LOGO;
    };

    const mainImage = (user) => {
        if (user?.gameType === 1 || user?.gameType === 2 || user?.gameType === 3) {
            const image = user?.memberImageList?.find(item => item.type === 3)?.image;
            return image ? image + Icon.ImageFooter : Icon.REFEREE_DEFALT_AVATAR;
        } else if (user?.gameRole === 1 && user?.gameType === 0) {
            const image = user?.memberImageList?.find(item => item.type === 4)?.image;
            return image ? image + Icon.ImageFooter : Icon.KEPENG_LOGO;
        }

        const isTwoCaptains = gameDetail.redCaptainId && gameDetail.greenCaptainId;
        const isConfirmed = captainWorkflow.showLineupSetup;

        if (isTwoCaptains && user?.gameType === 0) {
            const isRedCaptain = String(user.id) === String(gameDetail.redCaptainId);
            const isGreenCaptain = String(user.id) === String(gameDetail.greenCaptainId);

            if (!isConfirmed) {
                if (isRedCaptain) {
                    const type = getTeamColorType(gameDetail.redColor);
                    const image = user?.memberImageList?.find(item => item.type === type)?.image;
                    return image ? image + Icon.ImageFooter : getTeamDefaultAvatar(type);
                }
                if (isGreenCaptain) {
                    const type = getTeamColorType(gameDetail.greenColor);
                    const image = user?.memberImageList?.find(item => item.type === type)?.image;
                    return image ? image + Icon.ImageFooter : getTeamDefaultAvatar(type);
                }
                const image = user?.memberImageList?.find(item => item.type === 5)?.image;
                return image ? image + Icon.ImageFooter : Icon.PURPLE_DEFAILT_AVATAR;
            } else {
                if (user.gameTeam === 1) {
                    const type = getTeamColorType(gameDetail.greenColor);
                    const image = user?.memberImageList?.find(item => item.type === type)?.image;
                    return image ? image + Icon.ImageFooter : getTeamDefaultAvatar(type);
                } else if (user.gameTeam === 2) {
                    const type = getTeamColorType(gameDetail.redColor);
                    const image = user?.memberImageList?.find(item => item.type === type)?.image;
                    return image ? image + Icon.ImageFooter : getTeamDefaultAvatar(type);
                }
            }
        }

        const image = user?.memberImageList?.find(item => item.type === 0)?.image;
        return image ? image + Icon.ImageFooter : Icon.KEPENG_LOGO;
    };

    const defaultImage = (user) => {
        const image = user?.memberImageList
            ?.find(item => item.type === 0)
            ?.image
        if (image) {
            return image + Icon.ImageFooter;
        } else {
            return Icon.KEPENG_LOGO;
        }
    }

    const getUserDefaultImage = (user) => {
        const defaultImage = user?.memberImageList
            ?.find(item => item.type === 0)
            ?.image

        if (defaultImage) {
            return defaultImage + Icon.ImageFooter;
        } else {
            return Icon.KEPENG_LOGO;
        }
    }

    // 提取member item渲染 — 使用 mini-player-item 样式（与 othersTeam 一致）
    const renderMemberItem = (user, onClickHandler) => {
        let roleText = null;
        let roleStyle = {};
        if (user.gameType === 1) { roleText = '主裁'; roleStyle = { color: '#fbbf24', background: 'rgba(251, 191, 36, 0.15)', border: '1px solid rgba(251, 191, 36, 0.3)' }; }
        else if (user.gameType === 2) { roleText = '边裁'; roleStyle = { color: '#60a5fa', background: 'rgba(96, 165, 250, 0.15)', border: '1px solid rgba(96, 165, 250, 0.3)' }; }
        else if (user.gameType === 3) { roleText = 'VAR'; roleStyle = { color: '#c084fc', background: 'rgba(192, 132, 252, 0.15)', border: '1px solid rgba(192, 132, 252, 0.3)' }; }
        else if (user.gameType === 4) { roleText = '观众'; roleStyle = { color: '#86909C', background: 'rgba(22, 93, 255, 0.05)', border: '1px solid rgba(22, 93, 255, 0.1)' }; }

        return (
            <Grid.Item key={user.id}>
                <div className="mini-player-item" onClick={onClickHandler}>
                    <div className="mini-avatar-wrapper">
                        <img 
                            src={mainImage(user)} 
                            className="mini-avatar" 
                            style={{ 
                                boxShadow: 'none',
                                border: 'none'
                            }}
                            alt={user.name} 
                        />
                    </div>
                    <div className="mini-player-name" style={{ paddingBottom: roleText ? '2px' : '0' }}>{user.name}</div>
                    {roleText && (
                        <div style={{
                            fontSize: '10px',
                            fontWeight: '600',
                            marginTop: '2px',
                            padding: '1px 6px',
                            borderRadius: '6px',
                            display: 'inline-block',
                            letterSpacing: '0.5px',
                            lineHeight: '1.4',
                            ...roleStyle
                        }}>
                            {roleText}
                        </div>
                    )}
                </div>
            </Grid.Item>
        );
    };

    const getCurrentInfo = () => {
        if (gameDetail && Array.isArray(memberListInfo)) {
            const players = memberListInfo?.filter(user => user.gameType === 0);
            const showChangePositionDialog = (user) => {
                let refereeInfo = [];
                let teamInfo = [];
                let positionInfo = [];
                Dialog.show({
                    title: (
                        <div className="premium-dialog-header">
                            <span className="premium-dialog-title-icon">⚙️</span>
                            <span className="premium-dialog-title-text">更改状态</span>
                        </div>
                    ),
                    content: (
                        <div className="premium-dialog-container">
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px', padding: '10px', background: 'rgba(22, 93, 255, 0.05)', borderRadius: '12px' }}>
                                <img src={getUserDefaultImage(user)} style={{ width: '40px', height: '40px', borderRadius: '50%' }} alt={user.name} />
                                <div style={{ fontSize: '15px', fontWeight: 'bold', color: '#1D2129' }}>{user.name}</div>
                            </div>
                            {user.gameType === 0 ? (
                                <>
                                    <div className="premium-dialog-section-title">转入裁判组</div>
                                    <Selector
                                        className="premium-selector-container"
                                        columns={2}
                                        options={[
                                            { label: '主裁', value: 1 },
                                            { label: '边裁', value: 2 },
                                            { label: 'VAR', value: 3 },
                                            { label: '观众', value: 4 }
                                        ]}
                                        onChange={(arr, _) => refereeInfo = arr}
                                    />
                                </>
                            ) : (
                                <>
                                    <div className="premium-dialog-section-title">转入队伍</div>
                                    <Selector
                                        className="premium-selector-container"
                                        columns={2}
                                        options={teams}
                                        onChange={(arr, _) => teamInfo = arr}
                                    />
                                    <div className="premium-dialog-section-title" style={{ marginTop: '16px' }}>转入位置</div>
                                    <Selector
                                        className="premium-selector-container"
                                        columns={3}
                                        options={positions}
                                        onChange={(arr, _) => positionInfo = arr}
                                    />
                                </>
                            )}
                        </div>
                    ),
                    closeOnMaskClick: true,
                    actions: [
                        {
                            key: 'cancel',
                            text: '取消',
                            style: { color: '#86909C' },
                            onClick: () => Dialog.clear()
                        },
                        {
                            key: 'confirm',
                            text: '确认修改',
                            bold: true,
                            style: { color: '#3b82f6' },
                            onClick: () => {
                                const data = {
                                    team: Object.keys(teamInfo).length > 0 ? teamInfo[0] : null,
                                    position: Object.keys(positionInfo).length > 0 ? positionInfo[0] : null,
                                    referee: Object.keys(refereeInfo).length > 0 ? refereeInfo[0] : null,
                                    gameId: gameDetail.id,
                                    userId: user.id
                                };
                                Dialog.clear();
                                setJoinButtonLoading(true);
                                axios.post(API_ROUTES.game_changePosition, data, {})
                                    .then(() => {
                                        Toast.show({
                                            icon: 'success',
                                            content: '修改成功',
                                            duration: 2
                                        })
                                        getUserListInfo()
                                    })
                                    .catch(() => {
                                        Toast.show({
                                            icon: 'fail',
                                            content: '修改失败',
                                        })
                                    })
                                    .finally(() => setJoinButtonLoading(false));
                            }
                        }
                    ]
                });
            };

            const showPigeonWarningDialog = (user) => {
                Dialog.show({
                    title: (
                        <div className="premium-dialog-header" style={{ borderBottomColor: 'rgba(239, 68, 68, 0.2)' }}>
                            <span className="premium-dialog-title-icon" style={{ filter: 'drop-shadow(0 0 8px rgba(239, 68, 68, 0.6))' }}>🚨</span>
                            <span class="premium-dialog-title-text" style={{ background: 'linear-gradient(to right, #FF7D00, #ef4444)', WebkitBackgroundClip: 'text', color: 'transparent' }}>鸽子警告</span>
                        </div>
                    ),
                    content: (
                        <div className="premium-dialog-container" style={{ textAlign: 'center' }}>
                            <div style={{ margin: '10px 0 20px' }}>
                                <img src={getUserDefaultImage(user)} style={{ width: '56px', height: '56px', borderRadius: '50%', border: '2px solid rgba(239, 68, 68, 0.5)', filter: 'grayscale(0.5)' }} alt={user.name} />
                            </div>
                            <div style={{ color: '#4E5969', fontSize: '14px', lineHeight: '1.6', marginBottom: '8px' }}>
                                确认将 <strong style={{ color: '#1D2129', fontSize: '15px' }}>{user.name}</strong> 设为未到场并移入鸽子名单吗？
                            </div>
                            <div className="premium-confirm-warning" style={{ justifyContent: 'center' }}>
                                ⚠️ 此操作将影响其出勤记录
                            </div>
                        </div>
                    ),
                    closeOnMaskClick: true,
                    actions: [
                        {
                            key: 'cancel',
                            text: '取消',
                            style: { color: '#86909C' },
                            onClick: () => Dialog.clear()
                        },
                        {
                            key: 'confirm',
                            text: '确认放鸽子',
                            bold: true,
                            style: { color: '#ef4444' },
                            onClick: () => {
                                const data = {
                                    gameId: gameDetail.id,
                                    userId: user.id,
                                    arrive: 2
                                };
                                Dialog.clear();
                                axios.post(API_ROUTES.game_changePosition, data, {})
                                    .then(() => {
                                        Toast.show({
                                            icon: 'success',
                                            content: '已标记为鸽子',
                                        })
                                        getUserListInfo()
                                    })
                                    .catch(() => {
                                        Toast.show({
                                            icon: 'fail',
                                            content: '操作失败',
                                        })
                                    })
                            }
                        }
                    ]
                });
            };

            // 旧弹窗实现保留为兼容回退，当前头像点击统一进入新的单层管理面板。
            void showChangePositionDialog;
            void showPigeonWarningDialog;

            const renderUserInfo = (userInfoArray) => (
                userInfoArray.map((user, index) => renderMemberItem(user, () => {
                    if (memberInfo?.admin === 1) {
                        // 管理员直接进入单层到场管理面板，不再逐层打开状态和位置弹窗。
                        setAttendanceUser(user);
                    } else {
                        navigate(`/members/${user.id}`)
                    }
                }))
            );

            const referees = memberListInfo?.filter(user => [1, 2, 3, 4].includes(user.gameType))?.sort((a, b) => a.gameType - b.gameType);

            return (
                <div className="others-team-container">
                    <div className="member-category-card">
                        <div className="member-header-container">
                            <div className="member-category-title">
                                上场队员 ({players?.length})
                            </div>
                        </div>
                        <div className="member-category-content">
                            <Grid columns={5} gap={12}>{renderUserInfo(players)}</Grid>
                        </div>
                    </div>
                    {referees?.length > 0 && (
                        <div className="member-category-card">
                            <div className="member-header-container">
                                <div className="member-category-title">
                                    裁判组 ({referees.length})
                                </div>
                            </div>
                            <div className="member-category-content">
                                <Grid columns={5} gap={12}>{renderUserInfo(referees)}</Grid>
                            </div>
                        </div>
                    )}
                </div>
            );
        } else {
            return null;
        }
    };

    //待定人员
    const getTentativeUserList = () => {
        const tentativeUserInfo = memberListInfo?.filter(item => item.gameType === 6)
        if (tentativeUserInfo?.length > 0) {
            return (
                <div>
                    <Grid columns={5} gap={12}>
                        {tentativeUserInfo?.map(user => renderMemberItem(user, () => {
                            if (canManageMatch) {
                                // 待定成员直接使用与懒人报名相同的底部面板。
                                setLazySignupUser(user)
                            } else {
                                navigate(`/members/${user.id}`);
                            }
                        }))}
                    </Grid>
                </div>
            )
        } else {
            return <Empty description='暂无数据' />
        }
    }

    const teams = useMemo(() => [
        {
            label: getReadyTeamName(gameDetail, 1),
            value: 1,
        },
        {
            label: getReadyTeamName(gameDetail, 2),
            value: 2,
        },
    ], [gameDetail]);

    const positions = useMemo(() => [
        { label: '门将', value: 1 },
        { label: '边后卫', value: 2 },
        { label: '中后卫', value: 3 },
        { label: '后腰', value: 4 },
        { label: '边前卫', value: 5 },
        { label: '前腰', value: 6 },
        { label: '前锋', value: 7 },
    ], []);



    // Sub-component for categorized leave reasons with grid/list toggle
    const LeaveCategory = ({ reason, groupMembers, gIndex }) => {
        const [isExpanded, setIsExpanded] = useState(false);
        return (
            <div key={reason} className={`leave-reason-group ${gIndex === 0 ? 'first' : ''}`}>
                <div
                    className="leave-reason-header"
                    onClick={() => setIsExpanded(!isExpanded)}
                >
                    <div className="leave-reason-left">
                        <span className="leave-reason-text">{reason}</span>
                        <Badge content={groupMembers.length} color='#3b82f6' className="leave-reason-badge" />
                    </div>
                    <div className={`leave-category-chevron ${isExpanded ? 'rotated' : ''}`}>
                        <DownOutline fontSize={14} />
                    </div>
                </div>

                <div className="leave-category-content">
                    {isExpanded ? (
                        <div className="leave-items-list-detailed">
                            {groupMembers.map((user, index) => (
                                <div key={user.id || index} className="leave-item-row-detailed" onClick={() => {
                                    if (canManageMatch) {
                                        // 请假成员在详细列表中也从底部面板调整报名状态。
                                        setLazySignupUser(user)
                                    } else {
                                        navigate(`/members/${user.id}`);
                                    }
                                }}>
                                    <div className="leave-item-avatar-wrapper">
                                        <img src={defaultImage(user)} className="leave-item-avatar-small" alt={user.name} />
                                    </div>
                                    <div className="leave-item-content">
                                        <div className="leave-item-name-row">
                                            <span className="leave-item-name-bold">{user.name}</span>
                                            <span className="leave-item-tag">详情</span>
                                        </div>
                                        <div className="leave-item-remark-text">{user.remark || '未填写具体原因'}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="leave-items-grid-compact">
                            <Grid columns={5} gap={10}>
                                {groupMembers.map((user, index) => (
                                    <Grid.Item key={user.id || index} onClick={() => {
                                        if (canManageMatch) {
                                            // 请假成员在头像网格中复用同一个底部面板。
                                            setLazySignupUser(user)
                                        } else {
                                            navigate(`/members/${user.id}`);
                                        }
                                    }}>
                                        <div className="leave-grid-item-compact">
                                            <img src={defaultImage(user)} className="leave-grid-avatar-compact" alt={user.name} />
                                            <div className="leave-grid-name-compact">{user.name}</div>
                                        </div>
                                    </Grid.Item>
                                ))}
                            </Grid>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    const renderLeaveSection = (title, members) => {
        if (!members || members.length === 0) return null;

        const keywords = ['工作', '家庭', '身体', '饭局', '出差', '其他'];
        const groups = {
            '工作': [], '家庭': [], '身体': [], '饭局': [], '出差': [], '其他': []
        };

        members.forEach(user => {
            const remark = user.remark || '';
            const match = keywords.find(k => remark.startsWith(k));
            if (match) {
                groups[match].push(user);
            } else {
                groups['其他'].push(user);
            }
        });

        return (
            <div className="member-category-card" style={{ marginBottom: '20px' }}>
                <div className="member-header-container">
                    <div className="member-category-title">
                        {title} ({members.length})
                    </div>
                </div>
                <div className="leave-content-wrapper">
                    {Object.entries(groups).map(([reason, groupMembers], gIndex) => {
                        if (groupMembers.length === 0) return null;
                        return (
                            <LeaveCategory
                                key={reason}
                                reason={reason}
                                groupMembers={groupMembers}
                                gIndex={gIndex}
                            />
                        );
                    })}
                </div>
            </div>
        );
    }

    return (
        <div className="applicate-container has-unified-nav match-member-scope">
            <NavBar
                className="unified-navbar fixed"
                onBack={() => window.history.back()}
            >
                分队对阵准备
            </NavBar>
            <PullToRefresh
                onRefresh={async () => {
                    getGameDetail()
                    getUserListInfo()
                }}
            >

                <div className='body_detail' >
                    <GameTitleTeam gameDetail={gameDetail} getGameDetail={getGameDetail} />

                    <Card className="applicate-main-card" style={{ marginTop: '20px' }}>
                        <div className="premium-tab-switcher">
                            <button
                                className={`premium-tab-btn ${activeTab === 'team' ? 'active' : ''}`}
                                onClick={() => setActiveTab('team')}
                            >
                                <span className="premium-btn-icon">⚽</span> 分队
                            </button>
                            <button
                                className={`premium-tab-btn ${activeTab === '2' ? 'active' : ''}`}
                                onClick={() => setActiveTab('2')}
                                disabled={!gameDetail?.id}
                            >
                                <span className="premium-btn-icon">🍽️</span> 聚餐报名
                            </button>
                        </div>

                        <div className="premium-tab-outer-container">
                            {activeTab === 'team' && (
                                <div className="premium-tab-content-wrapper">
                                    {/* 低频赛前管理操作折叠展示，排阵主流程保持在首屏可见。 */}
                                    {canManageMatch && <details className="ready-management-details">
                                        <summary className="ready-management-summary">
                                            <span className="ready-management-summary-icon">⚙</span>
                                            <span className="ready-management-summary-text">
                                                <strong>赛前管理</strong>
                                                <small>赛段与临时人员管理</small>
                                            </span>
                                            {canSwapTeamMembers && <span className="ready-management-available">可对调</span>}
                                            <span className="ready-management-summary-chevron" aria-hidden="true">⌄</span>
                                        </summary>
                                     {canManageMatch ?
                                         <div className="ready-operation-panel">
                                             {/* 赛前管理中提供整队队员对调入口，两位队长保留在各自队伍。 */}
                                             {canSwapTeamMembers
                                                 ?
                                                 <div className="ready-management-swap">
                                                     <button
                                                         className="premium-btn-base premium-btn-admin ready-function-card ready-swap-button"
                                                         onClick={() => {
                                                             Dialog.confirm({
                                                                 title: '确认两队队员对调',
                                                                 // 两位队长留在原队，确认弹窗说明实际对调范围。
                                                                 content: `${greenCaptain?.name || '主队队长'}与${redCaptian?.name || '客队队长'}保留在原队，其余已分队队员整体加入对方队长的队伍。`,
                                                                 onConfirm: () => {
                                                                     const formData = new FormData();
                                                                     formData.append('gameId', gameDetail.id)
                                                                     axios.post(API_ROUTES.game_captainReturn, formData, {
                                                                         headers: {
                                                                             'Content-Type': 'multipart/form-data'
                                                                         }
                                                                     })
                                                                         .then(function (response) {
                                                                             const result = response.data
                                                                             if (result.code === 200) {
                                                                                 // 后端已清空双方首发，页面同时丢弃本地暂存阵容并刷新比赛阶段。
                                                                                 setTempLocalPos([])
                                                                                 localStorage.removeItem('memberTempPos')
                                                                                 getUserListInfo()
                                                                                 getGameDetail()
                                                                                 Toast.show({
                                                                                     icon: 'success',
                                                                                     content: "两队队员对调完成，请重新安排首发！"
                                                                                 })
                                                                             } else {
                                                                                 Toast.show({
                                                                                     icon: 'fail',
                                                                                     content: result.msg
                                                                                 })
                                                                             }
                                                                         })
                                                                         .catch(function (error) {
                                                                             Toast.show({
                                                                                 icon: 'fail',
                                                                                 content: "系统错误！请联系管理员",
                                                                             })
                                                                         });
                                                                 }
                                                             })
                                                         }}
                                                     >
                                                         <span className="premium-btn-icon">⇄</span> 对调两队队员
                                                     </button>
                                                     <span className="ready-management-swap-hint">队长留在原队 · 其余队员整体交换</span>
                                                 </div> : null
                                             }
                                             <Grid className="ready-control-grid" columns={2} gap={10}>
                                            {/* 管理员设置与辅助操作集中在控制面板中，样式按功能层级区分。 */}
                                            {/* 赛段节数属于比赛配置，仅管理员可修改；裁判仍可操作赛中记录。 */}
                                            {memberInfo?.admin === 1 && <Grid.Item span={1}>
                                                <button
                                                    className="premium-btn-base premium-btn-admin ready-function-card ready-config-card"
                                                    style={{ width: '100%' }}
                                                    onClick={() => {
                                                         let typeInfoInput = String(gameDetail?.gameCourse || '');
                                                        Dialog.confirm({
                                                            title: (
                                                                <div className="premium-dialog-header">
                                                                    <span className="premium-dialog-title-icon">⏱️</span>
                                                                    <span className="premium-dialog-title-text">选择赛段节数</span>
                                                                </div>
                                                            ),
                                                            content: (
                                                                <div className="premium-dialog-container">
                                                                    <div className="premium-dialog-section-title">选择比赛节数</div>
                                                                    <div className="segment-choice-list">
                                                                        {[
                                                                            ['1', '单节赛程', '常规比赛'],
                                                                            ['2', '两节赛程', '半场休息'],
                                                                            ['3', '三节赛程', '两段休息'],
                                                                            // 赛前设置与创建页共用 1～4 节的赛程范围。
                                                                            ['4', '四节赛程', '三段休息']
                                                                        ].map(([value, title, subtitle]) => (
                                                                            <button
                                                                                key={value}
                                                                                type="button"
                                                                                className={`segment-choice-button ${typeInfoInput === value ? 'is-selected' : ''}`}
                                                                                onClick={(event) => {
                                                                                    typeInfoInput = value;
                                                                                    // 直接切换按钮状态，避免旧 Radio 样式影响弹窗反馈。
                                                                                    event.currentTarget.parentElement.querySelectorAll('.segment-choice-button').forEach((button) => {
                                                                                        button.classList.toggle('is-selected', button === event.currentTarget);
                                                                                    });
                                                                                }}
                                                                            >
                                                                                <span className="segment-choice-title">{title}</span>
                                                                                <span className="segment-choice-subtitle">{subtitle}</span>
                                                                            </button>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            ),
                                                            onConfirm: () => {
                                                                if (!typeInfoInput) {
                                                                    Toast.show({
                                                                        content: '请选择赛段节数！',
                                                                        icon: 'fail'
                                                                    })
                                                                    return;
                                                                } else {
                                                                    Dialog.confirm({
                                                                        title: '提示',
                                                                        content: '确认修改比赛赛段节数吗?',
                                                                        onConfirm: () => {
                                                                            const dataPost = {
                                                                                gameId: gameDetail?.id,
                                                                                memberId: memberInfo?.id,
                                                                                gameCourse: typeInfoInput,
                                                                            }
                                                                            axios.post(API_ROUTES.game_updateGameInfo, dataPost, {})
                                                                                .then(function (response) {
                                                                                    if (response.data.code === 200) {
                                                                                        Toast.show({
                                                                                            content: '修改成功！',
                                                                                            icon: 'success',
                                                                                            afterClose: () => {
                                                                                                getGameDetail()
                                                                                            },
                                                                                        })
                                                                                    } else {
                                                                                        Toast.show({
                                                                                            content: response.data.msg,
                                                                                            icon: 'fail',
                                                                                            afterClose: () => {
                                                                                                getGameDetail()
                                                                                            },
                                                                                        })
                                                                                    }
                                                                                })
                                                                                .catch(function (error) {
                                                                                    Toast.show({
                                                                                        content: '修改失败,请重试!',
                                                                                        icon: 'fail'
                                                                                    })
                                                                                })
                                                                        },
                                                                    })
                                                                }
                                                            }
                                                        })
                                                    }}
                                                >
                                                    <span className="premium-btn-icon">⏱️</span>
                                                    <span className="ready-function-label">赛段节数</span>
                                                    <span className="ready-function-value">{gameDetail.gameCourse === 1 ? '单节' :
                                                        gameDetail.gameCourse === 2 ? '两节' :
                                                            gameDetail.gameCourse === 3 ? '三节' :
                                                                gameDetail.gameCourse === 4 ? '四节' : "未设置"}
                                                    </span>
                                                </button>
                                            </Grid.Item>}
                                             {false && (
                                                     <Grid.Item>
                                                <button
                                                    className="premium-btn-base premium-btn-admin ready-function-card ready-config-card"
                                                    style={{ width: '100%' }}
                                                    disabled={gameDetail?.typeInfo}
                                                    onClick={() => {
                                                        if (!gameDetail?.typeInfo) {
                                                             let typeInfoInput = String(gameDetail?.typeInfo || '');
                                                            Dialog.confirm({
                                                                title: (
                                                                    <div className="premium-dialog-header">
                                                                        <span className="premium-dialog-title-icon">📋</span>
                                                                        <span className="premium-dialog-title-text">确认阵容人数</span>
                                                                    </div>
                                                                ),
                                                                content: (
                                                                    <div className="premium-dialog-container">
                                                                        <div className="premium-dialog-section-title">选择场上人数</div>
                                                                         <div className="formation-choice-grid">
                                                                             {[
                                                                                 ['1', '8v8', '经典小场'],
                                                                                 ['4', '9v9', '中型球场'],
                                                                                 ['2', '11v11', '标准大球场'],
                                                                                 ['3', '12v12', '大乱斗场']
                                                                             ].map(([value, title, subtitle]) => (
                                                                                 <button
                                                                                     key={value}
                                                                                     type="button"
                                                                                     className={`formation-choice-button ${typeInfoInput === value ? 'is-selected' : ''}`}
                                                                                     onClick={(event) => {
                                                                                         typeInfoInput = value;
                                                                                         // 仅保留当前按钮的选中态，确保四个选项互斥。
                                                                                         event.currentTarget.parentElement.querySelectorAll('.formation-choice-button').forEach((button) => {
                                                                                             button.classList.toggle('is-selected', button === event.currentTarget);
                                                                                         });
                                                                                     }}
                                                                                 >
                                                                                     <span className="formation-choice-title">{title}</span>
                                                                                     <span className="formation-choice-subtitle">{subtitle}</span>
                                                                                 </button>
                                                                             ))}
                                                                         </div>
                                                                    </div>
                                                                ),
                                                                onConfirm: () => {
                                                                    const dataPost = {
                                                                        gameId: gameDetail?.id,
                                                                        memberId: memberInfo?.id,
                                                                        type: typeInfoInput,
                                                                    }
                                                                    axios.post(API_ROUTES.game_updateGameInfo, dataPost, {})
                                                                        .then(function (response) {
                                                                            if (response.data.code === 200) {
                                                                                Toast.show({
                                                                                    content: '修改成功！',
                                                                                    icon: 'success',
                                                                                    afterClose: () => {
                                                                                        getGameDetail()
                                                                                        localStorage.removeItem('memberTempPos')
                                                                                    },
                                                                                })
                                                                            } else {
                                                                                Toast.show({
                                                                                    content: response.data.msg,
                                                                                    icon: 'fail',
                                                                                    afterClose: () => {
                                                                                        getGameDetail()
                                                                                    },
                                                                                })
                                                                            }
                                                                        })
                                                                        .catch(function (error) {
                                                                            Toast.show({
                                                                                content: '修改失败,请重试!',
                                                                                icon: 'fail'
                                                                            })
                                                                        });
                                                                },
                                                            })
                                                        }
                                                    }}
                                                >
                                                    <span className="premium-btn-icon">📋</span>
                                                    <span className="ready-function-label">阵容人数</span>
                                                    <span className="ready-function-value">{gameDetail.typeInfo === 1 ? '8v8' :
                                                        gameDetail.typeInfo === 4 ? '9v9' :
                                                            gameDetail.typeInfo === 2 ? '11v11' :
                                                                gameDetail.typeInfo === 3 ? '12v12' : "未设置"}
                                                    </span>
                                                </button>
                                             </Grid.Item>
                                             )}
                                             {memberInfo?.admin === 1 && <Grid.Item>
                                                <button
                                                    className="premium-btn-base premium-btn-admin ready-function-card ready-action-card"
                                                    style={{ width: '100%' }}
                                                    onClick={() => {
                                                         let typeInfoInput = String(gameDetail?.typeInfo || '');
                                                        Dialog.confirm({
                                                            title: (
                                                                <div className="premium-dialog-header">
                                                                    <span className="premium-dialog-title-icon">🔄</span>
                                                                    <span className="premium-dialog-title-text">重选赛制</span>
                                                                </div>
                                                            ),
                                                            content: (
                                                                <div className="premium-dialog-container">
                                                                    <div className="premium-dialog-section-title">重选阵容人数</div>
                                                                     <div className="formation-choice-grid">
                                                                         {[
                                                                             ['1', '8v8'],
                                                                             ['4', '9v9'],
                                                                             ['2', '11v11'],
                                                                             ['3', '12v12']
                                                                         ].map(([value, title]) => (
                                                                             <button
                                                                                 key={value}
                                                                                 type="button"
                                                                                 className={`formation-choice-button ${typeInfoInput === value ? 'is-selected' : ''}`}
                                                                                 onClick={(event) => {
                                                                                     typeInfoInput = value;
                                                                                     // 四个阵容选项互斥，点击后只保留当前按钮高亮。
                                                                                     event.currentTarget.parentElement.querySelectorAll('.formation-choice-button').forEach((button) => {
                                                                                         button.classList.toggle('is-selected', button === event.currentTarget);
                                                                                     });
                                                                                 }}
                                                                             >
                                                                                 <span className="formation-choice-title">{title}</span>
                                                                             </button>
                                                                         ))}
                                                                     </div>
                                                                </div>
                                                            ),
                                                            onConfirm: () => {
                                                                if (!typeInfoInput) {
                                                                    Toast.show({
                                                                        content: '请选择阵容人数！',
                                                                        icon: 'fail'
                                                                    })
                                                                    return;
                                                                } else {
                                                                    Dialog.confirm({
                                                                        title: (
                                                                            <div className="premium-dialog-header">
                                                                                <span className="premium-dialog-title-icon">⚠️</span>
                                                                                <span className="premium-dialog-title-text">重置确认</span>
                                                                            </div>
                                                                        ),
                                                                        content: (
                                                                            <div className="premium-dialog-container">
                                                                                <div className="premium-confirm-warning">
                                                                                    修改阵容人数将会重置两个队长的阵容选择，是否继续?
                                                                                </div>
                                                                            </div>
                                                                        ),
                                                                        onConfirm: () => {
                                                                            const dataPost = {
                                                                                gameId: gameDetail?.id,
                                                                                memberId: memberInfo?.id,
                                                                                type: typeInfoInput,
                                                                            }
                                                                            axios.post(API_ROUTES.game_updateGameInfo, dataPost, {})
                                                                                .then(function (response) {
                                                                                    if (response.data.code === 200) {
                                                                                        Toast.show({
                                                                                            content: '修改成功！',
                                                                                            icon: 'success',
                                                                                            afterClose: () => {
                                                                                                getGameDetail()
                                                                                                localStorage.removeItem('memberTempPos')
                                                                                            },
                                                                                        })
                                                                                    } else {
                                                                                        Toast.show({
                                                                                            content: response.data.msg,
                                                                                            icon: 'fail',
                                                                                            afterClose: () => {
                                                                                                getGameDetail()
                                                                                            },
                                                                                        })
                                                                                    }
                                                                                })
                                                                                .catch(function (error) {
                                                                                    Toast.show({
                                                                                        content: '修改失败,请重试!',
                                                                                        icon: 'fail'
                                                                                    })
                                                                                })
                                                                        },
                                                                    })
                                                                }
                                                            }
                                                        })
                                                    }}
                                                >
                                                    <span className="premium-btn-icon">🔄</span>
                                                    <span className="ready-function-label">重选赛制</span>
                                                    <span className="ready-function-arrow">›</span>
                                                </button>
                                            </Grid.Item>}
                                             {gameDetail.gameType !== 4 && (
                                                 <>
                                                     <Grid.Item>
                                                         <TempSignupPopup gameDetail={gameDetail} memberListInfo={memberListInfo} getUserListInfo={getUserListInfo} />
                                                     </Grid.Item>
                                                     <Grid.Item>
                                                         <AddTempMember className="ready-function-card" gameDetail={gameDetail} getGameDetailInfo={getUserListInfo} type={1} />
                                                     </Grid.Item>
                                                       {false && (
                                                     <Grid.Item>
                                                        <button
                                                            className="premium-btn-base premium-btn-admin"
                                                            style={{ width: '100%' }}
                                                             onClick={() => {
                                                                 const lazyMember = memberListInfo?.filter(item =>
                                                                    ![0, 1, 2, 3, 4].includes(item.gameType) && item.tempMember === null
                                                                )
                                                                const memberOptions = lazyMember?.map(item => {
                                                                    return {
                                                                        label: (
                                                                            <div style={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'space-between',
                                                                            }}>
                                                                                <Image
                                                                                    src={mainImage(item)}
                                                                                    width={30}
                                                                                    height={30}
                                                                                    fit='cover'
                                                                                    style={{
                                                                                        borderRadius: 50
                                                                                    }}
                                                                                />
                                                                                <span>
                                                                                    {item.name}
                                                                                </span>
                                                                            </div>
                                                                        ),
                                                                        value: item.id
                                                                    }
                                                                })

                                                                Dialog.show({
                                                                    closeOnMaskClick: true,
                                                                    title: (
                                                                        <div className="premium-dialog-header">
                                                                            <span className="premium-dialog-title-icon">⚡</span>
                                                                            <span className="premium-dialog-title-text">临时报名</span>
                                                                        </div>
                                                                    ),
                                                                    content: (
                                                                        <div className="premium-dialog-container">
                                                                            <div className="premium-dialog-section-title">选择临时到场人员</div>
                                                                            <Selector
                                                                                className="premium-selector-container"
                                                                                columns={2}
                                                                                options={memberOptions}
                                                                                onChange={(arr, _) => {
                                                                                    const currentMember = memberListInfo?.filter(
                                                                                        item => item.id === arr[0]
                                                                                    )[0]

                                                                                    let chooseType = []
                                                                                    Dialog.confirm({
                                                                                        title: (
                                                                                            <div className="premium-dialog-header">
                                                                                                <span className="premium-dialog-title-icon">👤</span>
                                                                                                <span className="premium-dialog-title-text">到场类型</span>
                                                                                            </div>
                                                                                        ),
                                                                                        content: (
                                                                                            <div className="premium-dialog-container">
                                                                                                <div className="premium-dialog-section-title">选择 {currentMember.name} 的上场类型</div>
                                                                                                <Selector
                                                                                                    className="premium-selector-container"
                                                                                                    columns={2}
                                                                                                    options={[
                                                                                                        {
                                                                                                            label: '上场队员',
                                                                                                            value: 0
                                                                                                        }, {
                                                                                                            label: '主裁',
                                                                                                            value: 1,
                                                                                                        }, {
                                                                                                            label: '边裁',
                                                                                                            value: 2,
                                                                                                        }, {
                                                                                                            label: 'VAR',
                                                                                                            value: 3,
                                                                                                        }, {
                                                                                                            label: '观众',
                                                                                                            value: 4,
                                                                                                        }
                                                                                                    ]}
                                                                                                    onChange={(arr, _) => {
                                                                                                        chooseType = arr
                                                                                                        if (arr[0] === 0) {
                                                                                                            let teamChoose = [1];
                                                                                                            Dialog.confirm({
                                                                                                                title: (
                                                                                                                    <div className="premium-dialog-header">
                                                                                                                        <span className="premium-dialog-title-icon">🏟️</span>
                                                                                                                        <span className="premium-dialog-title-text">选择队伍</span>
                                                                                                                    </div>
                                                                                                                ),
                                                                                                                content: (
                                                                                                                    <div className="premium-dialog-container">
                                                                                                                        <div className="premium-dialog-section-title">选择 {currentMember.name} 的上场队伍</div>
                                                                                                                        <Selector
                                                                                                                            className="premium-selector-container"
                                                                                                                            columns={2}
                                                                                                                            defaultValue={[1]}
                                                                                                                            options={[
                                                                                                                                {
                                                                                                                                    label: getReadyTeamName(gameDetail, 1),
                                                                                                                                    value: 1
                                                                                                                                }, {
                                                                                                                                    label: getReadyTeamName(gameDetail, 2),
                                                                                                                                    value: 2,
                                                                                                                                }
                                                                                                                            ]}
                                                                                                                            onChange={(arr, _) => teamChoose = arr}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                ),
                                                                                                                onConfirm: () => {
                                                                                                                    Dialog.clear()
                                                                                                                    Toast.show({
                                                                                                                        icon: 'loading',
                                                                                                                        duration: '0'
                                                                                                                    })
                                                                                                                    const dataPost = {
                                                                                                                        gameId: gameDetail.id,
                                                                                                                        memberId: currentMember.id,
                                                                                                                        gameType: chooseType[0],
                                                                                                                        gameTeam: teamChoose[0]
                                                                                                                    }
                                                                                                                    axios.post(API_ROUTES.game_tempAddMember, dataPost, {})
                                                                                                                        .then(function (response) {
                                                                                                                            if (response.data.code === 200) {
                                                                                                                                Toast.show({
                                                                                                                                    content: '添加成功！',
                                                                                                                                    icon: 'success',
                                                                                                                                    afterClose: () => {
                                                                                                                                        getUserListInfo()
                                                                                                                                    }
                                                                                                                                })
                                                                                                                            } else {
                                                                                                                                Toast.show({
                                                                                                                                    content: response.data.msg,
                                                                                                                                    icon: 'fail',
                                                                                                                                    afterClose: () => {
                                                                                                                                        getUserListInfo()
                                                                                                                                    }
                                                                                                                                })

                                                                                                                            }
                                                                                                                        })
                                                                                                                        .catch(function (error) {
                                                                                                                            Toast.show({
                                                                                                                                content: '添加失败,请联系管理员!',
                                                                                                                                icon: 'fail'
                                                                                                                            })
                                                                                                                        })
                                                                                                                        .finally(() => {
                                                                                                                        });
                                                                                                                }
                                                                                                            })
                                                                                                        }
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                        ),
                                                                                        onConfirm: () => {
                                                                                            Toast.show({
                                                                                                icon: 'loading',
                                                                                                duration: '0'
                                                                                            })
                                                                                            const dataPost = {
                                                                                                gameId: gameDetail.id,
                                                                                                memberId: currentMember.id,
                                                                                                gameType: chooseType[0]
                                                                                            }
                                                                                            axios.post(API_ROUTES.game_tempAddMember, dataPost, {})
                                                                                                .then(function (response) {
                                                                                                    if (response.data.code === 200) {
                                                                                                        Toast.show({
                                                                                                            content: '添加成功！',
                                                                                                            icon: 'success',
                                                                                                            duration: 2
                                                                                                        })
                                                                                                        getUserListInfo()
                                                                                                    } else {
                                                                                                        Toast.show({
                                                                                                            content: response.data.msg,
                                                                                                            icon: 'fail',
                                                                                                        })
                                                                                                        getUserListInfo()
                                                                                                    }
                                                                                                })
                                                                                                .catch(function (error) {
                                                                                                    Toast.show({
                                                                                                        content: '添加失败,请联系管理员!',
                                                                                                        icon: 'fail'
                                                                                                    })
                                                                                                })
                                                                                                .finally(() => {
                                                                                                    Dialog.clear()
                                                                                                });
                                                                                        }
                                                                                    })

                                                                                }}
                                                                            />
                                                                        </div>
                                                                    )
                                                                })
                                                            }}
                                                        >
                                                            <span className="premium-btn-icon">⚡</span>
                                                            <span className="ready-function-label">临时报名</span>
                                                            <span className="ready-function-arrow">›</span>
                                                        </button>
                                                     </Grid.Item>
                                                      )}
                                                </>
                                            )}
                                            </Grid>
                                        </div>
                                        : null
                                    }
                                    </details>}



                                    {/* 裁判可开赛，但年会活动本身须先由管理员启动。 */}
                                    {captainWorkflow.canStartMatch && canManageMatch ?
                                        <button
                                            className="premium-btn-base premium-btn-neon-green ready-primary-action"
                                            style={{ width: '100%', marginTop: '16px' }}
                                            disabled={joinButtonLoading || (Number(gameDetail?.gameType) === 4 && currentYearId && (yearStatus === null || yearStatus === 2 || (yearStatus === 0 && memberInfo?.admin !== 1)))}
                                            onClick={() => {
                                                if (Number(gameDetail?.gameType) === 4 && yearStatus === 0) {
                                                    Dialog.confirm({
                                                        title: '开始年会并开赛？',
                                                        content: '将年会活动设为进行中，并立即开始这场比赛。',
                                                        onConfirm: () => startReadyMatch(true)
                                                    });
                                                } else {
                                                    startReadyMatch();
                                                }
                                            }}>
                                            <span className="premium-btn-icon">⚽</span> {yearStatus === 0 && Number(gameDetail?.gameType) === 4 ? (memberInfo?.admin === 1 ? '开始活动并开赛' : '等待管理员启动活动') : '比赛开始'}
                                        </button> : null
                                    }

                                    <GameStep gameDetail={gameDetail} yearStatus={yearStatus} />

                                    {canAccessTeamSetup ?
                                        <GameReadyStepOne
                                            gameDetail={gameDetail}
                                            memberListInfo={memberListInfo}
                                            memberInfo={memberInfo}
                                            getUserListInfo={getUserListInfo}
                                            defaultImage={defaultImage}
                                            getGameDetail={getGameDetail}
                                        />
                                        : null
                                    }

                                    {captainWorkflow.showLineupSetup && hasPendingTeamMembers
                                        && (memberInfo?.admin === 1 || isPendingTeamMember) ?
                                        <GameReadyStepOne
                                            pendingOnly
                                            gameDetail={gameDetail}
                                            memberListInfo={memberListInfo}
                                            memberInfo={memberInfo}
                                            getUserListInfo={getUserListInfo}
                                            defaultImage={defaultImage}
                                            getGameDetail={getGameDetail}
                                        />
                                        : null
                                    }

                                    {captainWorkflow.showLineupSetup ?
                                        <GameFirstInfo
                                            gameDetail={gameDetail}
                                            getGameDetail={getGameDetail}
                                            memberListInfo={memberListInfo}
                                            redCaptian={redCaptian}
                                            greenCaptain={greenCaptain}
                                            tempLocalPos={tempLocalPos}
                                            setTempLocalPos={setTempLocalPos}
                                            getUserListInfo={getUserListInfo}
                                        />
                                        : null
                                    }

                                    {gameDetail.gameType === 4 ?
                                        <AddReferee 
                                            gameDetail={gameDetail} 
                                            getGameDetail={getGameDetail} 
                                            getUserListInfo={getUserListInfo}
                                            memberListInfo={memberListInfo} 
                                        />
                                        :
                                        <>
                                            {getCurrentInfo()}

                                            {renderLeaveSection('请假人员', memberListInfo?.filter(item => item.gameType === 5))}

                                            {memberListInfo?.filter(item => item.gameType === 6).length > 0 && (
                                                <div className="member-category-card">
                                                    <div className="member-header-container">
                                                        <div className="member-category-title">
                                                            待定队员 ({memberListInfo?.filter(item => item.gameType === 6).length})
                                                        </div>
                                                    </div>
                                                    <div className="member-category-content">
                                                        {getTentativeUserList()}
                                                    </div>
                                                </div>
                                            )}

                                            {(() => {
                                                const pigeonList = memberListInfo?.filter(item => item.gameType === 7 && item.tempMember === null) || [];
                                                return pigeonList.length > 0 && (
                                                    <div className="member-category-card">
                                                        <div className="member-header-container">
                                                            <div className="member-category-title">
                                                                鸽子 ({pigeonList.length})
                                                            </div>
                                                        </div>
                                                        <div className="member-category-content">
                                                            <Grid columns={5} gap={12}>
                                                                {pigeonList.map((user, index) => (
                                                                    <Grid.Item key={index}>
                                                                         <div className="mini-player-item" onClick={() => {
                                                                             if (canManageMatch) {
                                                                                 // 懒人报名统一进入单层底部面板。
                                                                                 setLazySignupUser(user);
                                                                             } else {
                                                                                 navigate(`/members/${user.id}`);
                                                                             }
                                                                        }}>
                                                                            <div className="mini-avatar-wrapper">
                                                                                <img src={mainImage(user)} className="mini-avatar" alt={user.name} />
                                                                            </div>
                                                                            <div className="mini-player-name">{user.name}</div>
                                                                        </div>
                                                                    </Grid.Item>
                                                                ))}
                                                            </Grid>
                                                        </div>
                                                    </div>
                                                );
                                            })()}

                                            {(() => {
                                                const lazyList = memberListInfo?.filter(item => item.tempMember === null && item.gameType === null) || [];
                                                return lazyList.length > 0 && (
                                                    <div className="member-category-card">
                                                        <div className="member-header-container">
                                                            <div className="member-category-title">
                                                                懒人 ({lazyList.length})
                                                            </div>
                                                        </div>
                                                        <div className="member-category-content">
                                                            <Grid columns={5} gap={12}>
                                                                {lazyList.map((user, index) => (
                                                                    <Grid.Item key={index}>
                                                                         <div className="mini-player-item" onClick={() => {
                                                                             if (canManageMatch) {
                                                                                 // 懒人头像点击后直接进入单层底部报名面板。
                                                                                 setLazySignupUser(user);
                                                                             } else {
                                                                                 navigate(`/members/${user.id}`);
                                                                             }
                                                                        }}>
                                                                            <div className="mini-avatar-wrapper">
                                                                                <img src={mainImage(user)} className="mini-avatar" alt={user.name} />
                                                                            </div>
                                                                            <div className="mini-player-name">{user.name}</div>
                                                                        </div>
                                                                    </Grid.Item>
                                                                ))}
                                                            </Grid>
                                                        </div>
                                                    </div>
                                                );
                                            })()}

                                            {canManageMatch && !gameDetail?.typeInfo ?
                                                <AddTempMember gameDetail={gameDetail} type={1} getGameDetailInfo={getUserListInfo} /> : null
                                            }
                                        </>
                                    }
                                </div>
                            )}
                            {activeTab === '2' && (
                                <div className="premium-tab-content-wrapper">
                                    <DinnerInfo gameDetail={gameDetail} memberListInfo={memberListInfo} />
                                </div>
                            )}
                        </div>
                    </Card>
                </div>
            </PullToRefresh >
            <AttendanceManagePopup
                visible={Boolean(attendanceUser)}
                user={attendanceUser}
                avatar={attendanceUser ? getUserDefaultImage(attendanceUser) : ''}
                gameDetail={gameDetail}
                teams={teams}
                positions={positions}
                onClose={() => setAttendanceUser(null)}
                onUpdated={getUserListInfo}
            />
            <LazySignupPopup
                visible={Boolean(lazySignupUser)}
                user={lazySignupUser}
                avatar={lazySignupUser ? getUserDefaultImage(lazySignupUser) : ''}
                gameDetail={gameDetail}
                teams={teams}
                onClose={() => setLazySignupUser(null)}
                onUpdated={getUserListInfo}
            />
        </div >
    )

}
